import { Controller } from '@hotwired/stimulus';

/* Controller for hiding and disabling fields depending on checked property of checkbox */
export default class extends Controller {
  static targets = ['inputsContainer', 'ignoredInputWrapper', 'alsoToggle'];
  static values = {
    hiddenFor: Boolean,
    initial: Boolean,
    toggleable: Boolean,
  };

  connect() {
    let hidden = this.shouldHide(this.initialValue);
    if (this.hasInputsContainerTarget) {
      this.inputsContainerTarget.classList.toggle('hidden', hidden);
      this.alsoToggleTargets.forEach((el) => el.classList.toggle('hidden', hidden));
    }
    this.changeDisabledState(hidden);
  }

  shouldHide(value) {
    return value === this.hiddenForValue;
  }

  changed(event) {
    let hidden = this.shouldHide(event.target.checked);

    if (hidden) {
      this.inputsContainerTarget.classList.add('hidden');
      this.alsoToggleTargets.forEach((element) =>
        element.classList.add('hidden'),
      );
    } else {
      this.inputsContainerTarget.classList.remove('hidden');
      this.alsoToggleTargets.forEach((element) =>
        element.classList.remove('hidden'),
      );
    }

    this.changeDisabledState(hidden);
  }

  changeDisabledState(disable) {
    if (!this.hasInputsContainerTarget || !this.toggleableValue) {
      return;
    }

    this.inputsContainerTarget.querySelectorAll('input').forEach((item) => {
      let itemWrapper = item.closest('.wrapper');

      if (this.ignoredInputWrapperTargets.includes(itemWrapper)) {
        return;
      }

      if (disable) {
        item.setAttribute('disabled', 'disabled');
      } else {
        item.removeAttribute('disabled');
      }
    });
  }
}
